module.exports = __webpack_public_path__ + "img/pr-3.abb49336.png";